import { z } from 'zod'
import { CourtesyStatus, RewardCategory } from '~library/enums'

export const suitCommoditySchema = z.object({
  /** 分類選項 */
  classType: z.nativeEnum(RewardCategory),
  /** 分類次選項 */
  classSecondType: z.string(),
  /** 分類第三選項 */
  classThirdType: z.string(),
  /** 狀態 */
  status: z.nativeEnum(CourtesyStatus),
  /** 券號 */
  couponNo: z.string(),
  /** EMD號碼 */
  emdNo: z.string()
})

export interface SuitCommodity extends z.infer<typeof suitCommoditySchema> {}

export class SuitCommodity {
  constructor() {
    return {
      classType: RewardCategory.APPR,
      classSecondType: '',
      classThirdType: '',
      status: CourtesyStatus.A,
      couponNo: '',
      emdNo: ''
    }
  }
}
